import * as React from "react";

function NavBar() {
  return <p>NavBar is working!</p>
}

export default NavBar;